import { createStyles } from 'antd-style';

import { ThemeBorderRadius, ThemeColors, ThemeSpaces } from '../../theme';

export const useInlineDialogStyles = createStyles(() => ({
  inlineDialog: {
    position: 'relative',
    width: 280,
    height: 140,
    border: `1px solid ${ThemeColors.COLOR_WHITE}`,
    backgroundColor: ThemeColors.COLOR_WHITE2,
    boxShadow: `0 0 35px ${ThemeColors.COLOR_GREY6}`,
    borderRadius: ThemeBorderRadius.BORDER_RADIUS_MD,
    padding: `${ThemeSpaces.SPACE_NORM_25}px ${ThemeSpaces.SPACE_NORM}px ${ThemeSpaces.SPACE_NORM}px ${ThemeSpaces.SPACE_NORM}px`,

    'h2.ant-typography': {
      fontWeight: 300,
      marginBottom: ThemeSpaces.SPACE_MD,
    },

    'div.ant-typography': {
      lineHeight: '19px',
      marginBottom: 0,
    },
  },
  inlineDialogIcon: {
    position: 'absolute',
    top: 0,
    left: '50%',
    transform: 'translate(-50%, -50%)',
    borderRadius: '100%',

    '> *': {
      display: 'block',
      fontSize: 36,

      '&.fa-exclamation-triangle': {
        color: ThemeColors.COLOR_ORANGE3,

        '&::after': {
          zIndex: -1,
          content: '""',
          position: 'absolute',
          top: 6,
          bottom: 2,
          right: 10,
          left: 10,
          backgroundColor: ThemeColors.COLOR_WHITE,
          borderRadius: '100%',
        },
      },
    },
  },
}));
